import { TurretInfo } from "./TurretInfo";
import { GameConstants } from "../../../GameConstants";
import { UpgradeContainer } from "./UpgradeContainer";
import { GameVars } from "../../../GameVars";
import { GameManager } from "../../../GameManager";

export class UpgradesLayer extends Phaser.GameObjects.Container {

    private upgradeContainers: UpgradeContainer[];

    private creditsLabel: Phaser.GameObjects.Text;
    private turretInfo: TurretInfo;
    private numStars: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {

        super(scene);

        if (!this.scene.sys.game.device.os.desktop) {
            this.scaleX = GameVars.scaleX;
        }

        let woodBox = new Phaser.GameObjects.Image(this.scene, 0, GameConstants.GAME_HEIGHT, "texture_atlas_1", "wood_box");
        woodBox.setOrigin(0, 1);
        this.add(woodBox);

        this.creditsLabel = new Phaser.GameObjects.Text(this.scene, 150, 109,  GameVars.formatNumber(GameVars.gameData.coins), {fontFamily: "Dalek", fontSize: "28px", color: "#FFB519", align: "center"});
        this.creditsLabel.setOrigin(1, .5);
        this.creditsLabel.setShadow(4, 0, "#2D3441");
        this.add(this.creditsLabel);

        this.numStars = new Phaser.GameObjects.Text(this.scene, 245, 112,  GameManager.getTotalStars().toString(), {fontFamily: "Lithos", fontSize: "21px", color: "#ffffff", align: "center"});
        this.numStars.setOrigin(1, .5);
        this.add(this.numStars);

        this.upgradeContainers = [];

        for (let i = 0; i < 4; i++) {
            for (let j = 0; j < 2; j++) {

                const upgradeContainer = new UpgradeContainer(this.scene, 68 + j * 128, 220 + i * 154, (i * 2) + j, this);
                this.add(upgradeContainer);
                this.upgradeContainers.push(upgradeContainer);
            }
        }

        this.turretInfo = new TurretInfo(this.scene);
        this.add(this.turretInfo);
    }

    public update(): void {

        this.upgradeContainers.forEach(function (upgradeContainer: UpgradeContainer) {
            upgradeContainer.update();
        }); 
    }

    public setPreviousStars(): void {

        this.numStars.setText((GameVars.levelCompleted.totalPrevStars.toString()));
    }

    public addStar(x: number, y: number, numStars: number): void {

        this.numStars.setText((parseInt(this.numStars.text) + numStars).toString());
    }

    public updateInfo(): void {

        this.creditsLabel.setText(GameVars.formatNumber(GameVars.gameData.coins));

        for (let i = 0; i < this.upgradeContainers.length; i++) {
            this.upgradeContainers[i].updateInfo();
        }
    }

    public showTurretInfo(key: string, i: number, x: number, y: number): void {
        this.turretInfo.show(key, i, x, y); 
    }

    public hideTurretInfo(): void {
        this.turretInfo.hide(); 
    }
}
